<template>
  <AppModalPopup :popup-id="popupId" modal-type="logout-popup modal">
    <template #header>
      <h1>자동 로그아웃 안내</h1>
    </template>
    <template #default>
      <p class="t-center">10분 동안 사용하지 않아</p>
      <p class="t-center">잠시 후 자동으로 로그아웃 될 <br/>예정입니다.</p>
      <p class="t-center mt-8 mb-8"><strong class="fc-primary fz-18 fw-700">남은시간 {{ time }}</strong></p>
      <p class="t-center">로그인 시간을 연장하시려면 <br/>로그인 연장 버튼을 클릭해주세요.</p>
    </template>
    <template #footer>
      <div class="flex">
        <button type="button" class="btn btn-secondary ui-pop-close" @click="plusTime">
          로그인 연장
        </button>
        <button type="button" class="btn btn-primary ui-pop-close" @click="logout">
          로그아웃
        </button>
      </div>
    </template>
  </AppModalPopup>
</template>

<script setup>

import AppModalPopup from "@/components/atoms/AppModalPopup.vue";
import {togglePop} from "@/utils/commonUi";
import {useMemberStore} from "@/services/store/memberStore";
import axios from "axios";
import tokenService from "@/services/token.service";

const props = defineProps({
  time: String,
  popupId: String
})

const memberStore = useMemberStore();

const logout = () => {
  memberStore.logout();
  togglePop(props.popupId, false);
}

const plusTime = async () => {
  togglePop(props.popupId, false);
  let tokenData = JSON.parse(sessionStorage.getItem('token'));
  let refreshToken = tokenData.refToken;
  const response = await axios.post('/cmm/api/v1/member/getToken', {refToken: refreshToken},
      {headers: {authorization: `Bearer ${refreshToken}`}});
  if (response) {
    tokenService.updateToken(response.data, true);
    memberStore.member.tokenTimeCheck = false;
  }
}


</script>